"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function standardAffiliation(dataset1, dataset2) {
    return {
        name: dataset1 + ':' + dataset2,
        altName: dataset2 + ':' + dataset1,
        tableType: 'aff',
        grain: [
            dataset1 + '::id',
            dataset2 + '::id',
            'type',
        ],
        tableGrain: [
            '!' + dataset1,
            '!' + dataset2,
            'type',
        ],
        foreignKeys: [
            dataset1 + '::id',
            dataset2 + '::id',
        ]
    };
}
function standardKeyAffiliation(dataset1, dataset2) {
    return {
        name: dataset1 + ':' + dataset2,
        altName: dataset2 + ':' + dataset1,
        tableType: 'aff',
        grain: [
            dataset1 + '::key',
            dataset2 + '::key',
            'type',
        ],
        tableGrain: [
            '!' + dataset1,
            '!' + dataset2,
            'type',
        ],
        foreignKeys: [
            dataset1 + '::key',
            dataset2 + '::key',
        ]
    };
}
const aco_facility = standardAffiliation('aco', 'facility');
const aco_vendor = standardAffiliation('aco', 'vendor');
const aco_healthSystem = standardAffiliation('aco', 'health-system');
const aco_provider = standardAffiliation('aco', 'provider');
const aco_providerGroup = standardAffiliation('aco', 'provider-group');
const aco_payer = standardAffiliation('aco', 'payer');
const county_cbsa = standardKeyAffiliation('county', 'cbsa');
const cbsa_state = standardKeyAffiliation('cbsa', 'state');
const county_congressional_district = standardKeyAffiliation('county', 'congressional-district');
const county_state = standardKeyAffiliation('county', 'state');
const zcta_county = standardKeyAffiliation('zcta', 'county');
const aco_paymentArrangement = {
    name: 'aco:payment-arrangement',
    altName: 'payment-arrangement:aco',
    tableType: 'aff',
    grain: [
        'aco::id',
        'payment-arrangement::id::payment_arrangement_id',
        'type',
    ],
    tableGrain: [
        '!aco',
        '!payment-arrangement',
        'type',
    ],
    foreignKeys: [
        'aco::id',
        'id:payment-arrangement:payment_arrangement_id',
    ],
};
const baseSystem_facility = standardAffiliation('base-system', 'facility');
const facility_ehr = standardAffiliation('facility', 'ehr');
const facility_facility = {
    name: 'facility:facility',
    tableType: 'aff',
    grain: [
        'facility::id',
        'facility::id::affiliated_torch_facility_id',
        'type',
    ],
    tableGrain: [
        '!facility',
        '!affiliated-facility',
        'affiliated_torch_facility_id',
        'type',
    ],
    foreignKeys: [
        'facility::id',
        'torch_facility_id:affiliated-facility:affiliated_torch_facility_id',
    ],
};
const facility_npi = standardAffiliation('facility', 'npi');
const facility_clinic = {
    name: 'facility:clinic',
    altName: 'clinic:facility',
    tableType: 'aff',
    grain: [
        'facility::id',
        'clinic::id::clinic_npi',
        'type',
    ],
    tableGrain: [
        '!facility',
        'clinic_npi',
        '!npi',
        'type',
    ],
    foreignKeys: [
        'facility::id',
        'npi:clinic:clinic_npi',
    ],
};
const facility_payer = standardAffiliation('facility', 'payer');
const facility_provider = standardAffiliation('facility', 'provider');
const facility_providerGroup = standardAffiliation('facility', 'provider-group');
const healthSystem_baseSystem = standardAffiliation('health-system', 'base-system');
const healthSystem_facility = standardAffiliation('health-system', 'facility');
const healthSystem_npi = standardAffiliation('health-system', 'npi');
const healthSystem_healthSystem = {
    name: 'health-system:health-system',
    tableType: 'aff',
    grain: [
        'health-system::id',
        'health-system::id::aff_torch_health_system_id',
        'type',
    ],
    tableGrain: [
        '!health-system',
        'aff_torch_health_system_id',
        'type',
    ],
    foreignKeys: [
        'health-system::id',
        'torch_health_system_id:affiliated-health-system:aff_torch_health_system_id',
    ],
};
const org_org = {
    name: 'org:org',
    tableType: 'aff',
    grain: [
        'org::id',
        'org::id::affiliated_torch_org_id'
    ],
    tableGrain: [
        '!org',
        'affiliated_torch_org_id',
        'type'
    ],
    foreignKeys: [
        'org::id',
        'torch_org_id:affiliated-org:affiliated_torch_org_id'
    ]
};
const healthSystem_clinic = {
    name: 'health-system:clinic',
    altName: 'clinic:health-system',
    tableType: 'aff',
    grain: [
        'health-system::id',
        'clinic::id::clinic_npi',
        'type',
    ],
    tableGrain: [
        '!health-system',
        '!npi',
        'type',
    ],
    foreignKeys: [
        'health-system::id',
        'clinic_npi:npi::id',
    ],
};
const healthSystem_payer = standardAffiliation('health-system', 'payer');
const healthSystem_provider = standardAffiliation('health-system', 'provider');
const healthSystem_providerGroup = standardAffiliation('health-system', 'provider-group');
const npi_taxonomy = standardAffiliation('npi', 'taxonomy');
const payer_payer = {
    name: 'payer:payer',
    tableType: 'aff',
    grain: [
        'payer::id',
        'payer::id::affiliated_torch_payer_id',
        'type',
    ],
    tableGrain: [
        '!payer',
        'affiliated_torch_payer_id',
        'type',
    ],
    foreignKeys: [
        'payer::id',
        'torch_payer_id:affiliated-payer:affiliated_torch_payer_id',
    ],
};
const payer_payer_group = standardAffiliation('payer', 'payer-group');
const paymentArrangement_population = {
    name: 'payment-arrangement:population',
    altName: 'population:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'population::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!population',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'population::id',
    ],
};
const paymentArrangement_service = {
    name: 'payment-arrangement:service',
    altName: 'service:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'service::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!service',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'service::id',
    ],
};
const paymentArrangement_waiver = {
    name: 'payment-arrangement:waiver',
    altName: 'waiver:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'waiver::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!waiver',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'waiver::id',
    ],
};
const paymentArrangement_facility = {
    name: 'payment-arrangement:facility',
    altName: 'facility:payment-arrangement',
    tableType: 'aff',
    grain: [
        'facility::id',
        'payment-arrangement::id::payment_arrangement_id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!facility',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'facility::id',
    ],
};
const paymentArrangement_vendor = {
    name: 'payment-arrangement:vendor',
    altName: 'vendor:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'vendor::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!vendor',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'vendor::id',
    ],
};
const paymentArrangement_healthSystem = {
    name: 'payment-arrangement:health-system',
    altName: 'health-system:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'health-system::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!health-system',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'health-system::id',
    ],
};
const paymentArrangement_provider = {
    name: 'payment-arrangement:provider',
    altName: 'provider:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'provider::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!provider',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'provider::id',
    ],
};
const paymentArrangement_payer = {
    name: 'payment-arrangement:payer',
    altName: 'payer:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'payer::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!payer',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'payer::id',
    ],
};
const paymentArrangement_providerGroup = {
    name: 'payment-arrangement:provider-group',
    altName: 'provider-group:payment-arrangement',
    tableType: 'aff',
    grain: [
        'payment-arrangement::id::payment_arrangement_id',
        'provider-group::id',
        'type',
    ],
    tableGrain: [
        '!payment-arrangement',
        '!provider-group',
        'type',
    ],
    foreignKeys: [
        'id:payment-arrangement:payment_arrangement_id',
        'provider-group::id',
    ],
};
const clinic_clinic = {
    name: 'clinic:clinic',
    tableType: 'aff',
    grain: [
        'clinic::id::clinic_npi',
        'clinic::id::affiliated_clinic_npi',
    ],
    tableGrain: [
        '!npi',
        'affiliated_clinic_npi',
        'type',
    ],
    foreignKeys: [
        'clinic_npi:npi::id',
        'affiliated_clinic_npi:npi::id',
    ],
};
const provider_ehr = standardAffiliation('provider', 'ehr');
const providerGroup_ehr = standardAffiliation('provider-group', 'ehr');
const providerGroup_clinic = {
    name: 'provider-group:clinic',
    altName: 'clinic:provider-group',
    tableType: 'aff',
    grain: [
        'provider-group::id',
        'clinic::id::clinic_npi',
        'type',
    ],
    tableGrain: [
        '!provider-group',
        '!npi',
        'type',
    ],
    foreignKeys: [
        'provider-group::id',
        'clinic_npi:npi::id',
        'npi:clinic:clinic_npi'
    ],
};
const providerGroup_providerGroup = {
    name: 'provider-group:provider-group',
    tableType: 'aff',
    grain: [
        'provider-group::id',
        'provider-group::id::affiliated_torch_provider_group_id',
        'type',
    ],
    tableGrain: [
        '!provider-group',
        'affiliated_torch_provider_group_id',
        'type',
    ],
    foreignKeys: [
        'provider-group::id',
        'affiliated_torch_provider_group_id:provider-group:id',
    ],
};
const provider_clinic = {
    name: 'provider:clinic',
    altName: 'clinic:provider',
    tableType: 'aff',
    grain: [
        'provider::id',
        'clinic::id::clinic_npi',
        'type',
    ],
    tableGrain: [
        '!provider',
        '!npi',
        'type',
    ],
    foreignKeys: [
        'provider::id',
        'clinic_npi:npi::id',
        'npi:clinic:clinic_npi'
    ],
};
const provider_provider = {
    name: 'provider:provider',
    tableType: 'aff',
    grain: [
        'provider::id',
        'provider::id::affiliated_torch_provider_id',
        'type',
    ],
    tableGrain: [
        '!provider',
        'affiliated_torch_provider_id',
        'type',
    ],
    foreignKeys: [
        'provider::id',
        'affiliated_torch_provider_id:provider::id',
    ],
};
const provider_providerGroup = standardAffiliation('provider', 'provider-group');
exports.default = [
    aco_facility,
    aco_vendor,
    aco_healthSystem,
    aco_paymentArrangement,
    aco_provider,
    aco_providerGroup,
    aco_payer,
    baseSystem_facility,
    clinic_clinic,
    facility_ehr,
    facility_facility,
    facility_npi,
    facility_clinic,
    facility_payer,
    facility_provider,
    facility_providerGroup,
    healthSystem_baseSystem,
    healthSystem_facility,
    healthSystem_npi,
    healthSystem_healthSystem,
    org_org,
    healthSystem_clinic,
    healthSystem_provider,
    healthSystem_providerGroup,
    payer_payer,
    payer_payer_group,
    npi_taxonomy,
    paymentArrangement_population,
    paymentArrangement_service,
    paymentArrangement_waiver,
    paymentArrangement_facility,
    paymentArrangement_vendor,
    paymentArrangement_healthSystem,
    healthSystem_payer,
    paymentArrangement_provider,
    paymentArrangement_payer,
    paymentArrangement_providerGroup,
    provider_ehr,
    provider_clinic,
    provider_provider,
    provider_providerGroup,
    providerGroup_ehr,
    providerGroup_clinic,
    providerGroup_providerGroup,
    county_cbsa,
    cbsa_state,
    county_congressional_district,
    county_state,
    zcta_county
];
